import { Component, Inject, OnInit, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ArticalManagementService } from '../artical-management.service';
import { ModalArticalPreviewComponent } from '../modal-artical-preview/modal-artical-preview.component';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-modal-artical-poll',
  templateUrl: './modal-artical-poll.component.html',
  styleUrls: ['./modal-artical-poll.component.scss'],
})
export class ModalArticalPollComponent implements OnInit {
  @ViewChildren('allcanvas') myCharts: any;

  isLoading: boolean = false;
  modalData;
  pieData;
  options;
  pollData;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalArticalPreviewComponent>,
    public matDialog: MatDialog,
    private articalManagementService: ArticalManagementService
  ) {
    this.modalData = data;
    // // console.log(this.modalData);
  }

  ngOnInit(): void {
    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    this.articalManagementService
      .getPollById(this.modalData.articalId)
      .subscribe((res) => {
        this.isLoading = true;
        // // console.log(res);
        if (res.success) {
          this.pollData = res.result;

          let la = [];
          let da = [];
          for (
            let i = 0;
            i < this.pollData.DETAIL_POLL[0].POLL_CHOICE.length;
            i++
          ) {
            la.push(this.pollData.DETAIL_POLL[0].POLL_CHOICE[i].OPTION_VALUE);
            da.push(this.pollData.DETAIL_POLL[0].POLL_CHOICE[i].POLL_PERCEN);
          }
        }
        this.isLoading = false;
      });
    this.articalManagementService.getPollById(this.modalData.articalId).pipe(
      map(
        (res) => {
          this.isLoading = true;
          // console.log(res);
          if (res.success) {
            this.pollData = res.result;

            let la = [];
            let da = [];
            for (
              let i = 0;
              i < this.pollData.DETAIL_POLL[0].POLL_CHOICE.length;
              i++
            ) {
              la.push(this.pollData.DETAIL_POLL[0].POLL_CHOICE[i].OPTION_VALUE);
              da.push(this.pollData.DETAIL_POLL[0].POLL_CHOICE[i].POLL_PERCEN);
            }
            this.isLoading = false;
            if (la[0] && da[0]) {
              if (this.pollData.VOTE_COUNT > 0) {
                let myChart1 = new Chart('Chart', {
                  type: 'pie',
                  data: {
                    labels: la,
                    datasets: [
                      {
                        label: this.pollData.DETAIL_POLL[0].POLL_QUESTION,
                        data: da,
                        backgroundColor: ['#FF6384', '#36A2EB'],
                      },
                    ],
                  },
                  options: {
                    responsive: true,
                    plugins: {
                      tooltip: {
                        enabled: true,
                        callbacks: {
                          label(tooltipItems: any) {
                            let raw = +tooltipItems.formattedValue;
                            let data = raw.toFixed(1);
                            return `${data}%`;
                          },
                        },
                      },
                      title: {
                        display: true,
                        text: this.pollData.DETAIL_POLL[0].POLL_QUESTION,
                      },
                      legend: {
                        position: 'bottom',
                      },
                    },
                  },
                });
              }
            }
          }
        }
      )
    ).subscribe();
  }
  ngAfterViewInit() {
    // this.articalManagementService.getPollById(this.modalData.articalId).pipe(
    //   map(
    //     (res) => {
    //       this.isLoading = true;
    //       // console.log(res);
    //       if (res.success) {
    //         this.pollData = res.result;

    //         let la = [];
    //         let da = [];
    //         for (
    //           let i = 0;
    //           i < this.pollData.DETAIL_POLL[0].POLL_CHOICE.length;
    //           i++
    //         ) {
    //           la.push(this.pollData.DETAIL_POLL[0].POLL_CHOICE[i].OPTION_VALUE);
    //           da.push(this.pollData.DETAIL_POLL[0].POLL_CHOICE[i].POLL_PERCEN);
    //         }
    //         this.isLoading = false;
    //         if (la[0] && da[0]) {
    //           if (this.pollData.VOTE_COUNT > 0) {
    //             let myChart1 = new Chart('Chart', {
    //               type: 'pie',
    //               data: {
    //                 labels: la,
    //                 datasets: [
    //                   {
    //                     label: this.pollData.DETAIL_POLL[0].POLL_QUESTION,
    //                     data: da,
    //                     backgroundColor: ['#FF6384', '#36A2EB'],
    //                   },
    //                 ],
    //               },
    //               options: {
    //                 responsive: true,
    //                 plugins: {
    //                   tooltip: {
    //                     enabled: true,
    //                     callbacks: {
    //                       label(tooltipItems: any) {
    //                         let raw = +tooltipItems.formattedValue;
    //                         let data = raw.toFixed(1);
    //                         return `${data}%`;
    //                       },
    //                     },
    //                   },
    //                   title: {
    //                     display: true,
    //                     text: this.pollData.DETAIL_POLL[0].POLL_QUESTION,
    //                   },
    //                   legend: {
    //                     position: 'bottom',
    //                   },
    //                 },
    //               },
    //             });
    //           }
    //         }
    //       }
    //     }
    //   )
    // ).subscribe();
    // this.articalManagementService
    //   .getPollById(this.modalData.articalId)
    //   .subscribe((res) => {
    //     this.isLoading = true;
    //     // console.log(res);
    //     if (res.success) {
    //       this.pollData = res.result;

    //       let la = [];
    //       let da = [];
    //       for (
    //         let i = 0;
    //         i < this.pollData.DETAIL_POLL[0].POLL_CHOICE.length;
    //         i++
    //       ) {
    //         la.push(this.pollData.DETAIL_POLL[0].POLL_CHOICE[i].OPTION_VALUE);
    //         da.push(this.pollData.DETAIL_POLL[0].POLL_CHOICE[i].POLL_PERCEN);
    //       }
    //       this.isLoading = false;
    //       if (la[0] && da[0]) {
    //         if (this.pollData.VOTE_COUNT > 0) {
    //           let myChart1 = new Chart('Chart', {
    //             type: 'pie',
    //             data: {
    //               labels: la,
    //               datasets: [
    //                 {
    //                   label: this.pollData.DETAIL_POLL[0].POLL_QUESTION,
    //                   data: da,
    //                   backgroundColor: ['#FF6384', '#36A2EB'],
    //                 },
    //               ],
    //             },
    //             options: {
    //               responsive: true,
    //               plugins: {
    //                 tooltip: {
    //                   enabled: true,
    //                   callbacks: {
    //                     label(tooltipItems: any) {
    //                       let raw = +tooltipItems.formattedValue;
    //                       let data = raw.toFixed(1);
    //                       return `${data}%`;
    //                     },
    //                   },
    //                 },
    //                 title: {
    //                   display: true,
    //                   text: this.pollData.DETAIL_POLL[0].POLL_QUESTION,
    //                 },
    //                 legend: {
    //                   position: 'bottom',
    //                 },
    //               },
    //             },
    //           });
    //         }
    //       }
    //     }
    //   });
  }

  closeModal() {
    this.dialogRef.close(false);
  }
}
